// Module
var code = `<h4>{{ ::\$ctrl.bloque.t }}</h4> <div class="c__box"> <start-preg q="::\$q" cvmodel="::\$ctrl.cvmodel" params="::\$ctrl.params" ng-repeat="\$q in ::\$ctrl.bloque.qlist" principal="true"></start-preg> </div> `;
// Exports
module.exports = code;